//import CartLayout from './componentsTest/CartLayout';

// export default CartLayout;

import { Cart } from './Cart'
export default Cart;